<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createProyecto"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mFeedProjectsContentModalCreate.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <div class="m-feed-projects-content-modal-create">
          <span class="titulo">Selecciona una opción</span>
          <div class="display-flex-row-center margin-bottom-xsmall margin-top-small">
            <span
              class="project-option"
              @click="setTipoProyecto(0)"
            >
              <i :class="['fas fa-clipboard-list', tipoProyecto === 0 ? 'text-color-assets-primary' : 'text-color-black-35', 'margin-right-xsmall']"></i>
              <span :class="tipoProyecto === 0 ? 'font-weight-regular' : 'font-weight-light'">
                {{ $t('mFeedProjectsContentModalCreate.inputs.option.labelAsset') }}
              </span>
            </span>
            <span
              class="project-option"
              @click="setTipoProyecto(1)"
            >
              <i :class="['fas fa-map-marker-alt', tipoProyecto === 1 ? 'text-color-maps-primary' : 'text-color-black-35', 'margin-right-xsmall']"></i>
              <span :class="tipoProyecto === 1 ? 'font-weight-regular' : 'font-weight-light'">
                {{ $t('mFeedProjectsContentModalCreate.inputs.option.labelMap') }}
              </span>
            </span>
          </div>
          <small
            v-if="!tipoProyectoNotSelected && tipoProyecto === null"
            class="text-color-danger"
          >
            {{ $t('mFeedProjectsContentModalCreate.validation.option.required') }}
          </small>
        </div>

        <AtomInputPrimary
          v-model="proyecto.titulo"
          :inputError="$v.proyecto.titulo.$error"
          :label="$t('mFeedProjectsContentModalCreate.inputs.titulo.label')"
          :message="$t('mFeedProjectsContentModalCreate.inputs.titulo.message')"
          :messageError="messageErrorTitulo"
          name="titulo"
          type="text"
          @blur="$v.proyecto.titulo.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mFeedProjectsContentModalCreate.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeFeedProjectsContentModalCreate',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mFeedProjectsContentModalCreate.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      proyecto: {
        academia: '',
        proyecto_categoria: 1,
        proyecto_tipo: null,
        titulo: ''
      },

      tipoProyecto: null,
      tipoProyectoNotSelected: true
    }
  },

  validations: {
    proyecto: {
      titulo: {
        maxLength: maxLength(120),
        minLength: minLength(5),
        required
      }
    }
  },

  computed: {
    messageErrorTitulo () {
      return this.$validation.getValidationMessage('mFeedProjectsContentModalCreate', this.$v.proyecto.titulo, 'titulo')
    }
  },

  created () {
    this.proyecto.academia = this.$store.getters.getAcademyData.id
  },

  methods: {
    createProyecto () {
      this.$v.$touch()
      if (this.tipoProyecto !== null && !this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.proyecto.proyecto_tipo = this.tipoProyecto
        this.$services.create('proyecto', 'createProyecto', this.proyecto)
          .then(response => {
            this.$modal.closeModal()
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedProjectsContentModalCreate', 'createProyecto', 'success')
            if (this.proyecto.proyecto_tipo === 0) {
              this.$router.push(`/${this.$t('rPaths.asset')}/${response.data.id}/${this.$t('mEditionMenu.asset.card.subject')}`)
            } else {
              this.$router.push(`/${this.$t('rPaths.map')}/${response.data.id}/${this.$t('mEditionMenu.map.card.subject')}`)
            }
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedProjectsContentModalCreate', 'createProyecto', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      } else if (this.tipoProyecto === null) {
        this.tipoProyectoNotSelected = false
      }
    },

    setTipoProyecto (tipo) {
      this.tipoProyecto = tipo
      this.tipoProyectoNotSelected = false
    }
  }
}
</script>
